import React from "react";
import ButtonIcon from "../ui/ButtonIcon/ButtonIcon";
import { ReactComponent as SvgClose } from "../../assets/window-close.svg";

function CloseBtn({ loc, onClick }) {
    return (
        <ButtonIcon {...{ onClick, text: loc("buttons.close"), showText: false }}>
            <SvgClose />
        </ButtonIcon>
    );
}

export default CloseBtn;
